import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  TYPEAHEAD_FEATURE_KEY,
  TypeAHeadPartialState,
  TypeaHeadState,
} from './type-ahead.reducer';

export const getTypeAHeadState = createFeatureSelector<TypeaHeadState>(
  TYPEAHEAD_FEATURE_KEY,
);

export const getTypeaHead = createSelector(
  getTypeAHeadState,
  (state: TypeaHeadState) => state.typeaHead,
);

export const getTypeaHeadLoaded = createSelector(
  getTypeAHeadState,
  (state: TypeaHeadState) => state.loaded,
);

export const getTypeaHeadError = createSelector(
  getTypeAHeadState,
  (state: TypeaHeadState) => state.error,
);
